import React from 'react';
import { Link } from 'react-router-dom';
import PropertyFilterGrid from './PropertyFilterGrid';

const FeaturedProperties = () => (
  <section id="properties" className="featured-properties">
    <div className="container">
      <div className="section-header">
        <span className="section-label">Portafolio</span>
        <h2 className="section-title">Propiedades Destacadas</h2>
        <p className="section-subtitle">
          Explora mis listados actuales y propiedades vendidas recientemente en Quito y Los Valles
        </p>
      </div>

      <PropertyFilterGrid />

      <div className="properties-cta">
        <Link to="/propiedades" className="btn btn-primary">Ver Todas las Propiedades</Link>
        <p className="cta-subtext">O <a href="#contact">contáctame</a> para conocer más propiedades disponibles o negociar tu propiedad</p>
      </div>
    </div>
  </section>
);

export default FeaturedProperties;
